import { BaseApi } from '../baseApi';
import { router } from '../router';

export class LoginFormProvider extends BaseApi {
	public totalSecondsToLoad: number = 0 ;
	async activeLogin(data: any) {
		const startTime = performance.now();
		const resp = await this.post('/Authentication/ActiveLogin', data);
		const endTime  = performance.now() - startTime;
		let seconds = parseFloat((endTime / 1000).toFixed(2));
		this.totalSecondsToLoad = this.totalSecondsToLoad + seconds;
		return resp;
	}
	async logIn(data: any) {
		const startTime = performance.now();
		const resp = await this.post('/Authentication/Login', data);
		const endTime  = performance.now() - startTime;
		let seconds = parseFloat((endTime / 1000).toFixed(2));
		this.totalSecondsToLoad = this.totalSecondsToLoad + seconds;		
		return resp;
	}

	logOut() {
		router.replace('/');
		window.sessionStorage.setItem('loggedIn', '');
		return this.post('/Authentication/SignOut', undefined, { showError: false });
	}

	logOutIfApplicable() {
		return this.post('/Authentication/SignOutIfApplicable', undefined, { showError: false });
	}

	async loggedUser(jwt: any = null) {
		const startTime = performance.now();
		if(jwt!=null){
			this.removeAxiosJwtQuery();
		}
		const resp = await this.fetch('/Authentication/LoggedUzivatel', undefined, { showError: false });
		const endTime  = performance.now() - startTime;
		let seconds = parseFloat((endTime / 1000).toFixed(2));
		this.totalSecondsToLoad = this.totalSecondsToLoad + seconds;
		return resp;
	}
	async GRPLogin(jwt: any = null, tenantName: any = null) {
		const startTime = performance.now();
		this.setAxiosTenantQuery(tenantName!);
		this.setAxiosJwtQuery(jwt);
		const resp = await this.fetch('/Authentication/GRPLogin', undefined, { showError: false });
		const endTime  = performance.now() - startTime;
		let seconds = parseFloat((endTime / 1000).toFixed(2));
		this.totalSecondsToLoad = this.totalSecondsToLoad + seconds;
		return resp;
	}
	async GRPAuthCode(code: any = null) {
		const startTime = performance.now();
		const resp = await this.fetch('/Authentication/GRPAuthCode'+(code==null?'':'?code='+code), undefined, { showError: false });
		const endTime  = performance.now() - startTime;
		let seconds = parseFloat((endTime / 1000).toFixed(2));
		this.totalSecondsToLoad = this.totalSecondsToLoad + seconds;
		return resp;
	}
	GRPUrl(data: any) {
		return this.fetch('/Authentication/GRPUrl', undefined, { showError: false });
	}
	async loadLocalizations() {
		const startTime = performance.now();
		const resp = await this.fetch('/Resource', undefined, { showError: false });
		const endTime  = performance.now() - startTime;
		let seconds = parseFloat((endTime / 1000).toFixed(2));
		this.totalSecondsToLoad = this.totalSecondsToLoad + seconds;
		return resp;
	}

	async autoLogon(jwt: any = null) {
		let resp;
		const startTime = performance.now();
		if(window.sessionStorage.getItem('loggedIn')!=='' ){
			resp = await this.fetch('/Authentication/AutoLogon', undefined, { showError: false });
		}
		const endTime  = performance.now() - startTime;
		let seconds = parseFloat((endTime / 1000).toFixed(2));
		this.totalSecondsToLoad = this.totalSecondsToLoad + seconds;
		if(this.totalSecondsToLoad > 0){
			await this.logPerformance('LoggingPrp','Login[Get User Authentication Details]','Click',parseFloat(this.totalSecondsToLoad.toFixed(2)));
			this.totalSecondsToLoad = 0;
		}
		return resp;
	}

	resetPassword(
		data: {
			login: string,
			passwordOld: string,
			passwordNew1: string,
			passwordNew2: string,
		},
		tenantName?: string,
	) {
		const tenant = tenantName ? `?tenant=${tenantName}` : '';
		return this.post(`/Authentication/ResetPassword${tenant}`, data);
	}

	changePassword(
		data: {
			login?: string,
			passwordOld: string,
			passwordNew1: string,
			passwordNew2: string,
		},
		tenantName?: string,
	) {
		const tenant = tenantName ? `?tenant=${tenantName}` : '';
		return this.post(`/Authentication/ChangePassword${tenant}`, data);
	}
}
